import { FaChild, FaFileCsv } from 'react-icons/fa6'
import { MdElderlyWoman } from 'react-icons/md'
import { GiWarpPipe } from 'react-icons/gi'
import { Link } from 'react-router-dom'
import styles from './Dashboard.module.css'
import { useSelector } from 'react-redux'
import { users } from '../utils/users'

const cards = [
  {
    route: 'screening',
    Icon: FaFileCsv,
    title: 'EEG Screening Test',
    desc: 'Upload EEG data for analysis.',
    allowed: null,
  },
  {
    route: 'adhd',
    Icon: FaChild,
    title: 'ADHD Diagnosis',
    desc: 'View ADHD and cognitive reports for children.',
    allowed: [users.ajay, users.research],
  },
  {
    route: 'dementia',
    Icon: MdElderlyWoman,
    title: 'Dementia Diagnosis',
    desc: 'View dementia and cognitive reports for elderly.',
    allowed: [users.ajay, users.research],
  },
  {
    route: 'pipeline',
    Icon: GiWarpPipe,
    title: 'AI Pipeline',
    desc: 'AI Pipeline for training and testing',
    allowed: [users.ajay, users.research],
  },
]

const Dashboard = () => {
  const { user } = useSelector((state) => state.auth)

  return (
    <div className={styles.dashboardContainer}>
      {cards
        .filter(({ allowed }) => !allowed || allowed.includes(user?.id))
        .map(({ route, Icon, title, desc }) => (
          <Link to={route} className={`dashboard-cards ${styles.card}`} key={route}>
            <div className={styles.iconWrapper}>
              <Icon size={48} />
            </div>
            <div className={styles.cardTitle}>{title}</div>
            <div className={styles.cardDesc}>{desc}</div>
          </Link>
        ))}
    </div>
  )
}

export default Dashboard
